<template>
  <div class="page">
    <div class="main-container">
      <div class="content">
        <div class="content-topic">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="1.为什么申请提现失败？" name="1">
              <div class="item-content">
                <p>提现不成功可能是如下原因:</p>
                <p>1 ．在申请提现前未完成真人认证和实名认证，若未完成，请先前往“我的认证”进行认证；</p>
                <p>2 ．账户实名信息与提现账号姓名信息不一致。</p>
                <p>提现失败，积分会原路退回并下发官方通知，请根据提示原因操作后重新发起提现哦。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="2.积分兑换的金币在哪里查看？" name="2">
              <div class="item-content">
                <p>积分兑换成金币是12小时内到账，你可以点击 收支记录 查看具体的金币消费记录。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="3.提现提示需要认证？" name="3">
              <div class="item-content">
                <p>在申请积分兑换之前，您的账号需要真人认证、实名认证都通过后才能提交申请。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="4.申请提现的时候账号信息填错了怎么办？" name="4">
              <div class="item-content">
                <p>账号填写错误是无法进行打款的，提现对应金币是直接退回到提现账号的，收到退回消息后，可以点击我的-收益-兑换记录查看退回金币记录，您可以重新填写正确的提现账号信息后再申请提现。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="5.积分提现钱为什么还不到账？可以在哪里查看？" name="5">
              <div class="item-content">
                <p>您好，系统显示兑换成功以后，您可以检查您的提现账户信息，进行核实。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="6.私聊回复信息为什么没有获得积分？" name="6">
              <div class="item-content">
                <p>为了双方更好的交流互动，若双方互相关注成为好友之后，双方是可以免费发送信息的哦，您也可以通过语音、视频通话，收礼物等方式获得积分呢，建议您可以多多体验使用相应功能~</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="7.私聊回复信息为什么得到的积分不一样？" name="7">
              <div class="item-content">
                <p>发消息方需付金币，12小时内回复即可获得相应积分，请您以实际到账为准。</p>
                <p>可以在积分清单核对一下是否收到积分，聊天界面积分系统显示有可能延迟，如果有问题可以提供对方ID给在线客服处理。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="8.私聊对方主动发消息，为什么回复后没积分？" name="8">
              <div class="item-content">
                <p>当对方设置发消息收费时，发消息给对方需付金币，对方12小时内回复即可获得相应积分。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="9.如何兑换积分？" name="9">
              <div class="item-content">
                <p>点击积分商城 即可选择兑换金币、提现、贵族、商城装扮等。</p>
                <p>温馨提示：</p>
                <p>1）兑换金币、贵族特权、商城装扮是实时到账的；</p>
                <p>2）积分提现是12小时内到账。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="10.如何撤销兑换？" name="10">
              <div class="item-content">
                <p>1)积分兑换金币、贵族、商城装扮，均是实时到账的，兑换成功无法撤销或退回</p>
                <p>2)积分兑换提现，未打款前可以联系客服申请驳回，进入打款状态无法撤销;若打款失败兑换积分将退回到账号可重新提交</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="11.如何获得积分？" name="11">
              <div class="item-content">
                <p>1）聊天能得到积分，收到对方赠送礼物也可获得积分；</p>
                <p>2）语音通话和视频通话也可以获得积分。</p>
                <p>3）点击<span class="blue-text" @click="handleSpanClick('toIntegral')">积分兑换</span> 即可在积分商城选择兑换金币、提现、特权贵族。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="12.提现记录在哪里查看？" name="12">
              <div class="item-content">
                <p>可以在 我的兑换 查看积分兑换及提现记录。</p>
                <p>在积分兑换过程中遇到问题，请联系官方在线客服咨询，快速解决问题。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="13.提现到账时间/提现还没到账？" name="13">
              <div class="item-content">
                <p>提现打款:</p>
                <p>1)首次提现5元面额是实时到账的，提现其他面额一般情况下12小时内到账。</p>
                <p>2)每日提现有次数限制，建议不要频繁操作</p>
                <p>4)打款是批量进行的，都会依次到账，留意通知，注意查收。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="14.提现到账的金额为什么不一样？" name="14">
              <div class="item-content">
                <p>1)提现金额累计超过500元，需要缴纳税费，提现到账后会扣取相应的手续费，还望理解；</p>
                <p>2)积分商城兑换提现所需积分请以页面实际显示为准；</p>
                <p>3)建议在使用过程中维护好账号，系统也会根据账号使用情况进行综合评估；</p>
                <p>4)账号积分还可以在积分商城兑换金币、特权权限等。</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="15.积分提现方式有哪些？" name="15">
              <div class="item-content">
                <p>积分提现目前仅支持支付宝提现方式，请以实际页面推荐显示为准。</p>
                <p>温馨提示：支付宝收款账号必须与陌生约聊账号实名信息保持一致，否则将会导致提现失败</p>
              </div>
            </el-collapse-item>
            <el-collapse-item title="16.积分可以聊天吗？" name="16">
              <div class="item-content">
                <p>您好，不可以，金币可用来在软件内聊天和赠送礼物。</p>
                <p>您可以点击软件底部【我】-【积分】，就可以看到积分能兑换金币，聊天是消耗金币</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";
export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
    }
  },

  methods: {
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
  }
}
</script>

<style scoped>

.icon-top {
  width: 100%;
  height: 143px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.icon-item {
  width: 80px;
  height: 102px;
  border-radius: 8px;
}

.hr {
  height: 12px;
  width: 100%;
  background: #F9FAFC;
}

.content {
  width: 100%;
}

.content-title {
  margin-top: 20px;
  margin-left: 13px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}


/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color: #3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 12px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}*/
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}
.main-container {
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}

.content .content-topic:last-child {
  margin-bottom: 70px;
}

.content-topic {
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}

.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}

.content-topic .el-collapse-item__header {
  font-size: 15px;
}

.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/page/Integral.vue